import { Modal } from "react-bootstrap";
import FormInputs from "../../components/UI/FormInputs";
import { useEffect, useState } from "react";
import { isSet } from "../../utils/commonUtils";
import Button from "react-bootstrap/Button";
import WithRoutify from "../../hoc/WithRoutify";
import AddLab from "./AddLab";
// import AddVaccine from "./AddVaccine"; // deprecated in favor of ActivityChart, kept for reference
import ActivityCharts from "./EmployeeVisitDetailView/RightContent/ActivityChart";
import { hasActivityConsent, hasConsentForm, isLaboratoryVisitCategory, isMobileHealth, isPhysicalVisitCategory, isWorkCompVisitCategory } from "../../utils/visitUtils";
import PatientFormService from "../../services/PatientFormService";
import { activateKioskSession, buildKioskPatientFormUrl, KIOSK_DEFAULT_RETURN_PATH } from "../../utils/patientFormKiosk";

const PatientFormModel = (props) => {
  const { isOpen, visitId, visitData, visitCategory, Loader, Toast, navigate, services, contractService, activityList, physicalServices, forKiosk = false } = props;
  console.log("visitdata",visitData);
  console.log("visitCategory",visitCategory);
  console.log("visitData?.screen_type",visitData?.screen_type);
  console.log('activityList',activityList);
  const [validation, setValidation] = useState({});
  const [formdata, setFormData] = useState({});
  const [labFormCompleted,setLabFormCompleted]=useState(false);
  // const [initialCheckboxes, setInitialCheckboxes] = useState({}); 
  
  useEffect(() => {
    const initialCheckboxState = {};
    inputFields.forEach(field => {
      // Don't set demographics verification to 1 by default if employee already verified
      if (field.name === 'patient_demographics_verification') {
        // Check if employee has already verified demographics
        const isEmployeeVerified = visitData?.employee?.is_demographics_verified === true || 
                                   visitData?.employee?.is_demographics_verified === 1;
        initialCheckboxState[field.name] = (!field.readOnly && field.show && !isEmployeeVerified) ? 1 : 0;
      } else {
        initialCheckboxState[field.name] = !field.readOnly && field.show ? 1 : 0;
      }
    });
    setFormData(initialCheckboxState);
  }, [visitData]);
  
  
  
  
  
  const changeHandler = (value, fieldName, e) => {
    setFormData({ ...formdata, [fieldName]: value });
  }
  const formSubmitHandler = async() => {
    const hasSelection = inputFields.some(
      (field) => field.show && Number(formdata[field.name]) === 1
    );
    if (!hasSelection) {
      Toast.error("Select at least one form to send to the patient.");
      return;
    }
    try{
    Loader(true);
    let payload={
      'visit_id':visitData.visit_id,
      'visit_category':visitCategory,
      'company_id':visitData.company.company_uuid,
      'employee_id':visitData.employee.employee_id,
      'clinic_id':visitData.employee.clinic_id,
      'organization_id':visitData.company.organization_uuid,
      'patient_demographics_verification':formdata.patient_demographics_verification,
      'new_patient_intake_form':formdata.new_patient_intake_form,
      'patient_medical_history':formdata.patient_medical_history,
      'treatment_testing_consent':formdata.treatment_testing_consent,
      'medical_history_questionnaire':formdata.medical_history_questionnaire,
      'upload_required_id':formdata.upload_required_id,
      'emr_history':formdata.emr_history,
      'upload_additional_documents':formdata.upload_additional_documents,
      'mh_medical_history_questionnaire':formdata.mh_medical_history_questionnaire,
      'actvity_consents':formdata.activity_consents_acknowledgement,
      'questionnaires_send_to_patient':formdata.questionnaires_send_to_patient,
      'baseUrl':process.env.REACT_APP_BASEURL,
      ...(forKiosk ? { suppress_patient_forms_notifications: true } : {}),
      //`${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    }
    console.log('Patient Form Payload:', payload);
    console.log('questionnaires_send_to_patient value:', formdata.questionnaires_send_to_patient);
    const response=await PatientFormService.sentPatientFormEmail(payload);
    Loader(false);
    if(response.code === 200){
        if (forKiosk) {
          let id = response?.data?.patient_form_id;
          let unifiedToken = response?.data?.token ?? null;
          const manifestResend = response?.data?.manifest_resend === true;
          if (!id) {
            Loader(true);
            const latest = await PatientFormService.getLatestPatientFormByVisit(
              visitData.visit_id
            );
            Loader(false);
            if (latest?.code === 200 && latest?.data?.patient_form_id) {
              id = latest.data.patient_form_id;
              if (!unifiedToken && latest.data.token) {
                unifiedToken = latest.data.token;
              }
            }
          }
          if (id) {
            const returnPath =
              props.location?.pathname?.includes("/visits") ||
              props.location?.pathname?.includes("/appointments")
                ? props.location.pathname.split("?")[0] || KIOSK_DEFAULT_RETURN_PATH
                : KIOSK_DEFAULT_RETURN_PATH;
            activateKioskSession({ patientFormId: id, returnPath, unifiedToken });
            navigate(
              buildKioskPatientFormUrl(id, {
                unifiedToken,
                manifestResend,
              })
            );
            Toast.success("Opening patient forms in kiosk mode.");
          } else {
            Toast.warning(
              "Forms were saved but the kiosk link could not be opened. Try again or use Resend Patient Forms."
            );
          }
          props.modalToogleHandler(true);
          return;
        }
        props.modalToogleHandler(true);
       Toast.success("Email Sent to Patient Successfully");
    }else if(response.code === 422){
        Toast.error(response.data)
    }
   
  }catch(err){
          Loader(false);
          Toast.error("something Went wrong");
  }
  }

  const inputFields = [
    {
      type: "Checkbox",
      label: "Send Patient Demographics Verification",
      name: "patient_demographics_verification",
      readOnly: false,
      show: !visitData?.employee?.is_demographics_verified && 
            !visitData?.demographics_verification_sent && 
            !visitData?.patient_demographics_verification,
    },
    {
      type: "Checkbox",
      label: "New Patient Intake Forms",
      name: "new_patient_intake_form",
      readOnly: hasConsentForm(visitData?.snapClinicConsentForm),
      show:true,
    },
    {
      type: "Checkbox",
      label: "Activity Consents", // You can change this label
      name: "activity_consents_acknowledgement", // A unique name for the checkbox
      show: true, // This is the key part
      // Add any other properties you need, like 'readOnly' or default values
      readOnly: hasActivityConsent(visitData),
    },
    {
      type: "Checkbox",
      label: "EMR History",
      name: "emr_history",
      // show:isWorkCompVisitCategory(visitCategory,0),
      show:isWorkCompVisitCategory(visitData?.screen_type ||  visitCategory,0),
      readOnly: false,
    },
    {
      type: "Checkbox",
      label: "Patient Medical History",
      name: "patient_medical_history",
      show: isPhysicalVisitCategory(visitCategory) && (Array.isArray(visitData?.mapping_activity) && visitData?.mapping_activity?.some(activity => activity?.activity?.activity_type === 'Provider Exam')),
      readOnly: false,
    },
    {
      type: "Checkbox",
      label: "Questionnaires Send to Patient",
      name: "questionnaires_send_to_patient",
      show: Array.isArray(visitData?.mapping_activity) && visitData.mapping_activity.some(activity => {
        const activityType = activity?.activity?.activity_type;
        const activityName = activity?.activity?.activity_name;
        return (
          (activityType === 'Screening' && activityName === 'Screening - TB Skin Test') ||
          activityType === 'Minimal Exam' ||
          activityType === 'Non DOT Exam - BP / Vision / Audio' ||
          activityType === 'Exam - Non DOT - Hearing Audio' ||
          activityType === 'Respirator Fit Test'
        );
      }),
      readOnly: false,
    },
    {
      type: "Checkbox",
      label: "Treatment & Testing Consents",
      name: "treatment_testing_consent",
      readOnly: true,
      show:true,
    }, 
    // {
    //   type: "Checkbox",
    //   label: "Medical History Questionnaire",
    //   name: "medical_history_questionnaire",
    //   readOnly: true,
    //   show:true,
    // },
    {
      type: "Checkbox",
      label: "Mobile Health - Medical History Questionnaire",
      name: "mh_medical_history_questionnaire",
      show: (isPhysicalVisitCategory(visitCategory)&& isMobileHealth(services,contractService,activityList,physicalServices)),
      readOnly:false,
    },
    {
      type: "Checkbox",
      label: "Upload Required ID",
      name: "upload_required_id",
      show:true,
      // show: false,
      readOnly: false,
    },
    {
      type: "Checkbox",
      label: "Upload Additional Optional Documents",
      name: "upload_additional_documents",
      show:true,
      // show: false,
      readOnly: false,
    },

  ];
  const addLabFormHandler=()=>{
    setLabFormCompleted(true)
  }
  console.log('labformCompleted',labFormCompleted);
  return (
    <>
      {
        isLaboratoryVisitCategory(visitCategory) && labFormCompleted !== true && !forKiosk ? (
          <LabNotification
          addLabFormHandler={addLabFormHandler}
          visitData={visitData}
          visitId={visitId}
          Loader={Loader}
          Toast={Toast}
           />
        ) : (
          <Modal
            show={true}
            onHide={() => props.modalToogleHandler(true)}
            dialogClassName="hResponsive"
            keyboard={false}
            backdrop="static"
          >
            <div className="sh_modalBox">
              <Modal.Header closeButton>
                <Modal.Title>
                  <h6 className="text-lg mb-0 font-weight-bold">{"Patient Forms"}</h6>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  {inputFields &&
                    inputFields.map((field, index) =>
                      field.show&& (
                      <div className={`col-12 ${validation[field.name] ? 'was-validated' : ''}`} key={index}>
                        <div className="form-check form-check-inline d-inline-flex pl-0">
                          <FormInputs {...field}  value={isSet(formdata[field.name], '')} changeHandler={(value, e) => changeHandler(value, field.name, e)} isChecked={!field.readOnly}
                           id={field.name } />
                          <label htmlFor={field.name} className=" text-sm opacity-75 text-truncate mb-0 pl-2">
                            {field.label}
                          </label>
                          {isSet(validation[field.name], "") !== "" ? (
                            <span className="text-danger m-1">
                              {isSet(validation[field.name], "")}
                            </span>
                          ) : ("")}
                        </div>
                      </div>
                    ))}
                </div>
              </Modal.Body>

              <Modal.Footer className="d-flex justify-content-center">
                <Button
                  variant="primary"
                  className=" "
                  onClick={() => formSubmitHandler()}
                >
                  {forKiosk ? "Open in Kiosk" : "Send to Patient /Employee"}
                </Button>
                {!forKiosk && (
                  <>
                    <Button
                      variant="primary"
                      className=" "
                      onClick={() => props.modalToogleHandler(true)}
                    >
                      Do Not Send
                    </Button>
                    <Button
                      variant="primary"
                      className=" "
                      onClick={() => {
                        const unCheckFormData = {};
                        inputFields.forEach((field) => {
                          unCheckFormData[field.name] = 0;
                        });
                        setFormData(unCheckFormData);
                      }}
                    >
                      Uncheck All
                    </Button>
                  </>
                )}
              </Modal.Footer>
            </div>
          </Modal>
        )}
    </>
  );
}
const LabNotification = (props) => {
  const {addLabFormHandler,visitData,visitId,Loader,Toast}=props
  const [isLabModelOpen, setLabModalOpen] = useState(false);
  const [isVaccineModelOpen, setVaccineModalOpen] = useState(false);
  const [showLabNotification, setShowLabNotification] = useState(true);
  const [option,setOption]=useState();
  const [labCompleted,setLabCompleted]=useState(false);
  const [vaccineCompleted,setVaccineCompleted]=useState(false);
  console.log('LabNotification','lab=>',labCompleted,'vaccine=>',vaccineCompleted);
  const labToogleHandler = () => {
    setLabCompleted(true);
    setLabModalOpen(!isLabModelOpen);
  }
  const vaccineToogleHandler = () => {
    setVaccineCompleted(true);  
    setVaccineModalOpen(!isVaccineModelOpen);
  }
  const addFormHandler=(type)=>{
    if (labCompleted==false) {
      labToogleHandler();
      setVaccineModalOpen(false);
      return;
    }
    if (vaccineCompleted==false) {
      vaccineToogleHandler();
      setLabModalOpen(false);
      return; 
    }
    setShowLabNotification(false)
    addLabFormHandler();
  }

  return (
    <>
      {
        isLabModelOpen ?
          <AddLab
            modelTitle={"Add Lab"}
            isOpen={isLabModelOpen}
            visitId={visitId}
            modalToogleHandler={()=>addFormHandler('lab')}
            fetchRecords={() => { }}
          />
          :
          ''

      }
      {
        isVaccineModelOpen ?
          <ActivityCharts
            chartDetails={{
              activity_name: "Vaccine",
              activity_type: "Vaccine",
              actitivity_id: null,
              mapping_id: null,
              hasOrder: "false",
            }}
            isOpen={isVaccineModelOpen}
            visitDetails={visitData || {}}
            fetchVisitDetails={() => { }}
            employeeDetails={visitData?.employee || {}}
            companyDetails={visitData?.company || {}}
            lookupsOptions={{}}
            stateList={[]}
            toogleHanlder={()=>{addFormHandler('vaccine');setVaccineCompleted(true)}}
            Loader={Loader || (() => {})}
            Toast={Toast || { success: () => {}, error: () => {} }}
          />
          :
          ''
      }
      {/* Vaccine editing now uses ActivityChart instead of AddVaccine.
          Previous AddVaccine modal is kept here for reference.
      {
        isVaccineModelOpen ?
          <AddVaccine
            isOpen={isVaccineModelOpen}
            visitId={visitId}
            fetchRecords={() => { }}
            modalToogleHandler={()=>{addFormHandler('vaccine');setVaccineCompleted(true)}}
            fromChart={false}
          />
          :
          ''
      } */}

      <Modal
        show={true}
          onHide={addLabFormHandler}
        dialogClassName="hResponsive"
        keyboard={false}
        backdrop="static"
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="text-lg mb-0 font-weight-bold">{"Add Lab /Vaccine"}</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row pl-2">
              Do you want to create Labs/Vaccine?
            </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="primary"
              className=" "
              onClick={() => {labToogleHandler();setVaccineCompleted(true);setLabCompleted(true)}}
            >
              Add Lab
            </Button>
            <Button
              variant="primary"
              className=" "
              onClick={() => {vaccineToogleHandler();setVaccineCompleted(true);setLabCompleted(true)}}
            >
              Add Vaccine
            </Button>
            <Button
              variant="primary"
              className=""
              onClick={() => {labToogleHandler();setLabCompleted(true)}}

            >
              Both
            </Button>
            {/* <Button
              variant="primary"
              className=""
              onClick={() => {setOption('none')}}
            >
              None
            </Button> */}
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
}
const PatientFormModelWithHoc = WithRoutify(PatientFormModel);
export { PatientFormModelWithHoc, LabNotification };